import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { CredentialsModel } from 'app/views/user/models/credentials.model';

@Component({
    selector: 'psm-reauthenticate-form',
    templateUrl: 'reauthenticateForm.component.html',
    styleUrls: ['reauthenticateForm.component.scss']
})

export class ReauthenticateFormComponent {
    @Output() public loginSucceeded: EventEmitter<void> = new EventEmitter<void>();
    @Output() public loginFailed: EventEmitter<void> = new EventEmitter<void>();
    public password: string;
    public isWaiting: boolean;

    private logger: Logger;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        loggerFactory: LoggerFactory
    ) {
        this.logger = loggerFactory.create('LoginComponent');
    }

    public async login() {
        this.isWaiting = true;
        if (await this.authService.reauthenticate(this.password)) {
            this.clear();
            this.loginSucceeded.emit();
        } else {
            this.loginFailed.emit();
        }

        this.isWaiting = false;
    }

    private clear() {
        this.password = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reauthenticateForm/reauthenticateForm.component.ts